import React, { Fragment, useEffect } from "react";

import { Star16Filled, Flash16Filled } from "@fluentui/react-icons";
import {
  Button,
  Menu,
  MenuTrigger,
  MenuList,
  MenuItem,
  MenuPopover,
  Switch,
} from "@fluentui/react-components";
import CreditCarte from "./CreditCarte";

/**
 * Liste des offres de crédits disponibles dans la boutique de crédits.
 */
const subscriptionPlans = [
  {
    type: "62 500 Crédits + 12 500 gratuits!", // Offre de crédits
    price: "24,99 CAD", // Prix du plan
    description: "", // Description (vide pour le moment)
    couleur: "#FFF1C2", // Couleur de fond pour l'offre
    boutonTexte: "Acheter", // Texte affiché sur le bouton
    boutonCouleur: "#E5A000", // Couleur du bouton
    fonctionnalites: [], // Liste des fonctionnalités (vide pour le moment)
    icone: Flash16Filled, // Icône associée à l'offre
  },

  {
    type: "25 000 Crédits + 1000 gratuits!",
    price: "9,99 CAD",
    description: "",
    couleur: "#BBFFC3",
    boutonTexte: "Acheter",
    boutonCouleur: "#187A00",
    fonctionnalites: [],
    icone: Star16Filled,
  },
  {
    type: "12 500 Crédits",
    description: "",
    price: "4,99 CAD",
    couleur: "#E1E1E1",
    boutonTexte: "Acheter",
    boutonCouleur: "#000000",
    fonctionnalites: [],
    icone: null,
  },
];

/**
 * Interface définissant les propriétés du composant Credit.
 */
interface CreditPageProps {
  handlePayment: (type: string) => void;
}

/**
 * Composant Credit : représente la page de la boutique de crédits.
 * Affiche une liste de cartes de crédits disponibles à l'achat.
 */
const Credit = (props: CreditPageProps) => {
  return (
    <Fragment>
      {/* Titre de la page */}
      <h1 style={{ textAlign: "center", lineHeight: "30px" }}>Boutique de crédits</h1>

      {/* Affichage des plans d'abonnement sous forme de cartes */}
      {subscriptionPlans.map((unCredit, index) => (
        <CreditCarte key={index} {...unCredit} handlePayment={props.handlePayment} />
      ))}
    </Fragment>
  );
};

export default Credit;
